// インデックス以外のページでは別タブリンクにアイコン付与（ヘッダーとフッターのリンクを除外）
document.addEventListener('DOMContentLoaded', function () {
  const links = document.querySelectorAll('a:not(header a):not(footer a)');

  links.forEach((link) => {
    const url = new URL(link.href, window.location.origin);

    const iconElement = link.querySelector('i');
    if (iconElement && iconElement.classList.contains('fa-brands')) {
      return;
    }

    if (url.origin !== window.location.origin) {
      link.setAttribute('target', '_blank');
      link.setAttribute('rel', 'noopener noreferrer');

      const icon = document.createElement('i');
      icon.classList.add('fa-solid', 'fa-up-right-from-square');

      link.append(icon);
      link.insertAdjacentHTML('beforeend', ' ');
    }
  });
});
